<template>
  <Header
    city
    hide-category-on-mobile
    is-home-page
    :external-home-link="configuration?.homepageUrl"
    :partner-logo-url="configuration?.logo"
  />
  <slot v-bind="$attrs" />
  <NavigationSidebar class="fixed bottom-0 left-0" />
  <Footer />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { NavigationSidebar, Header, Footer } from '@/3_widgets/Navigation'
import { useConfiguration } from '@/5_entities/Configuration'

const { configuration } = storeToRefs(useConfiguration())
</script>
